<template>
	<svg :width="diameter" :height="diameter">
		<path :d="_path" :fill="color" />
	</svg>
</template>

<script>
	export default {
		data() {
			return {
				rotation: 0,
				angle: 0,
				sweep: Math.PI / 4,
				start: null
			};
		},
		props: {
			diameter: {
				type: Number,
				default: 50
			},
			width: {
				type: Number,
				default: 3
			},
			backgroundColor: {
				type: String,
				default: '#FF000022'
			},
			color: {
				type: String,
				default: '#f72223'
			},
			minSweep: {
				type: Number,
				default: 2 * Math.PI * 0.05
			},
			maxSweep: {
				type: Number,
				default: 2 * Math.PI * 0.8
			}
		},
		computed: {
			_radius() {
				return this.diameter / 2;
			},
			_center() {
				return {
					x: this._radius,
					y: this._radius
				};
			},
			_path() {
				const l = this.arc('M', this._center, this._radius, this.angle, this.sweep, this.rotation);
				const s = this.arc('L', this._center, this._radius - this.width, this.angle + this.sweep, -this.sweep, this.rotation);

				return `${l.path} ${s.path}`;
			}
		},
		methods: {
			arc(f, center, radius, angle, sweep, rotation) {
				const r = radius;
				const a = angle;
				const c = center;
				const d = sweep % (2 * Math.PI);
				const rm = this.rotMatrix(rotation);
				const ra = rotation / (2 * Math.PI) * 360;

				const [sX, sY] = this.addVector(this.mulMatrix(rm, [r * Math.cos(a), r * Math.sin(a)]), [c.x, c.y]);
				const [eX, eY] = this.addVector(this.mulMatrix(rm, [r * Math.cos(a + d), r * Math.sin(a + d)]), [c.x, c.y]);

				var fA;
				var fS;

				if (d >= 0) {
					fA = d > Math.PI ? 1 : 0;
					fS = d > 0 ? 1 : 0;
				} else {
					fA = d < -Math.PI ? 1 : 0;
					fS = d > 0 ? 1 : 0;
				}

				return {
					path: `${f} ${sX} ${sY} A ${r} ${r} ${ra} ${fA} ${fS} ${eX} ${eY}`,
					start: {
						x: sX,
						y: sY
					},
					end: {
						x: eX,
						y: eY
					}
				};
			},
			mulMatrix([[a, b], [c, d]], [x, y]) {
				return [
					a * x + b * y,
					c * x + d * y
				];
			},
			rotMatrix(x) {
				return [
					[Math.cos(x), -Math.sin(x)],
					[Math.sin(x), Math.cos(x)]
				];
			},
			addVector([a1, a2], [b1, b2]) {
				return [
					a1 + b1,
					a2 + b2
				];
			},
			step(timestamp) {
				if (!this.start) this.start = timestamp;
				this.render(timestamp - this.start);
			},
			render(ms) {
				this.rotation 	= (ms / 1000) * (Math.PI * 2);
				this.angle 		= (((Math.sin((ms / 3000) * (2 * Math.PI) + Math.PI) + 1) / 2) * (this.maxSweep - this.minSweep));
				this.sweep 		= this.minSweep + (((Math.sin((ms / 3000) * (2 * Math.PI)) + 1) / 2) * (this.maxSweep - this.minSweep));

				window.requestAnimationFrame(this.step);
			}
		},
		created() {
			window.requestAnimationFrame(this.step);
		}
	}
</script>

<style lang="scss" scoped>

</style>